module.exports = __webpack_public_path__ + "img/sting_my-songs.aabc5570.jpg";